import { render } from "./BelizePage.vue?vue&type=template&id=3981b9d0&scoped=true"
import script from "./BelizePage.vue?vue&type=script&lang=js"
export * from "./BelizePage.vue?vue&type=script&lang=js"

import "./BelizePage.vue?vue&type=style&index=0&id=3981b9d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3981b9d0"]])

export default __exports__